// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"712":"908124a8","2267":"5b65a775","3076":"9637eae2","3576":"8e49258a","4931":"a580757d","6872":"de1148e3","8872":"98b39491","9888":"37a499b5"}[chunkId] + ".css";
};